// Supported languages for the app
export type SupportedLanguage = 'english' | 'hindi' | 'marathi' | 'kannada' | 'telugu' | 'tamil' | 'malayalam' | 'urdu' | 'punjabi' | 'bengali' | 'gujarati' | 'odia';

export const SUPPORTED_LANGUAGES: { value: SupportedLanguage; nativeLabel: string; toggleChar?: string; label?: string }[] = [
  { value: 'english', nativeLabel: 'English', toggleChar: 'A', label: 'English' },
  { value: 'hindi', nativeLabel: 'हिन्दी', toggleChar: 'आ', label: 'Hindi' },
  { value: 'marathi', nativeLabel: 'मराठी', toggleChar: 'म', label: 'Marathi' },
  { value: 'kannada', nativeLabel: 'ಕನ್ನಡ', toggleChar: 'ಅ', label: 'Kannada' },
  { value: 'telugu', nativeLabel: 'తెలుగు', toggleChar: 'అ', label: 'Telugu' },
  { value: 'tamil', nativeLabel: 'தமிழ்', toggleChar: 'அ', label: 'Tamil' },
  { value: 'malayalam', nativeLabel: 'മലയാളം', toggleChar: 'അ', label: 'Malayalam' },
  { value: 'urdu', nativeLabel: 'اردو', toggleChar: 'اُ', label: 'Urdu' },
  { value: 'punjabi', nativeLabel: 'ਪੰਜਾਬੀ', toggleChar: 'ਅ', label: 'Punjabi' },
  { value: 'bengali', nativeLabel: 'বাংলা', toggleChar: 'অ', label: 'Bengali' },
  { value: 'gujarati', nativeLabel: 'ગુજરાતી', toggleChar: 'અ', label: 'Gujarati' },
  { value: 'odia', nativeLabel: 'ଓଡ଼ିଆ', toggleChar: 'ଅ', label: 'Odia' },
]; 